import angular from 'angular';
import blogComponent from './blog.component';
import BlogService from './blog.service';
import blogConfig from './blog.config';
import blogDetailModule from './blog-detail/blog-detail';
import relatedPostsModule from './related-posts/related-posts';


let blogModule = angular.module('app.blog',[blogDetailModule.name,relatedPostsModule.name])
  .component('blog', blogComponent)
  .service('BlogService', BlogService)
  .config(blogConfig);

export default blogModule;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/blog/blog.js
 **/